import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useForm, useWatch, Controller, useFieldArray } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { NavLink } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import moment from 'moment';
import $ from 'jquery';
import _groupBy from 'lodash/groupBy';

import { Grid, MenuItem, Checkbox } from '@mui/material';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import iconAttchmentCV from 'assets/img/icons/attchment-cv.svg';
import iconCvDefault from 'assets/img/icons/cv-default.svg';

import './styles.scss';
import styles from './style.module.scss';
import Validate from './Validate';
import { errorSubmit, checkMaxDateToday } from 'helpers';
import { apiCreateCandidateCV, apiUploadCV } from 'api/managerCandidate';
import { useListSkillAddStandardIndex, useListUsers } from 'hook/useMasterData';
import { useGetListLanguage } from 'hook/useManagerCandidate';
import { useParseCv } from 'hook/useParseCv';
import { getParseCvOptions } from 'helpers/cvParser';
import { HTTP_OK } from 'constants/StatusCode.js';
import {
  DEFAULT_PAGE_MUI,
  CODE_DATA_EXISTS,
  DEFAULT_LIMIT_10,
  MAX_LENGTH_25,
  MAX_LENGTH_250,
  MAX_LENGTH_50,
  MAX_LENGTH_256,
  LOADING_SM,
  MAX_LENGTH_300,
  ROWS_TEXT_AREA_6,
} from 'constants/index.js';
import { USE_GET_LIST_CANDIDATE } from 'constants/ManagerCandidate';
import { SOURCE_CV_TEXT } from 'constants/ManagerCandidate';
import AlertComponent from 'components/Alert/index.js';
import CustomInputYup from 'components/InputYupAndMui/CustomInputYup';
import CusromInputNumber from 'components/InputYupAndMui/CusromInputNumber';
import DateDay from 'components/ReactForm/DateDay';
import CustomRadioInput from 'components/InputYupAndMui/CustomRadioInputForm';
import SelectField from 'components/ReactForm/SelectField';
import ButtonComponent from 'components/Buttons';
import ModalComponent from 'components/Modal';
import AutoCompleteCustom from 'components/AutoCompleteCustom/AutoComplete.js';
import Loading from 'components/Loading';
import CvParseStatus from 'components/CvParseStatus';
import AddMoreLanguage from './AddMoreLanguage';
import { alertConfirmDuplicateCandidate } from 'helpers/manageCandidate';

const CreateCandidateModal = (props) => {
  const { isShowModal, setShowModal, dataListSchool, dataPosition, dataLevel, dataExperience, dataListSourceCV } =
    props;
  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const [stateButton, setStateButton] = useState(false);
  const [isShowAlert, setShowAlert] = useState(false);
  const [isShowAlertError, setShowAlertError] = useState(false);
  const [message, setMessage] = useState('');
  const [attchmentCV, setAttchmentCV] = useState();
  const [dataUser, setDataUser] = useState([]);
  const [namePresenter, setNamePresenter] = useState('');
  const [sourceCvText, setSourceCvText] = useState('');
  const [errorDate, setErrorDate] = useState({});
  const [dataDetail, setDataDetail] = useState();
  const [filter, setFilter] = useState({ page: DEFAULT_PAGE_MUI, limit: DEFAULT_LIMIT_10, key_word: '' });
  const { data: uDataSkill } = useListSkillAddStandardIndex();
  const { data: uDataUsers, isLoading: isLoadingDataUsers } = useListUsers({
    key_word: filter.key_word,
    page: filter.page + 1,
    per_page: filter.limit,
  });
  const [defaultLanguage] = useState({
    candidate_languages: [{ language_id: undefined, level: '' }],
  });
  const { data: uDataListLanguage } = useGetListLanguage();
  // Ngày sinh/trường học không tự nhận setValue -> remount với giá trị AI điền
  const [aiBirthday, setAiBirthday] = useState(null);
  const [aiFillKey, setAiFillKey] = useState({ birthday: 0, school: 0 });

  const {
    handleSubmit,
    control,
    register,
    setValue,
    getValues,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm({
    resolver: yupResolver(Validate(sourceCvText)),
    mode: 'onChange',
  });

  const handleRedirect = useRef({});
  const mapLanguage = useRef({});

  useEffect(() => {
    if (uDataUsers?.data) {
      setDataUser((prev) => {
        if (filter.clear_data) {
          return [...uDataUsers?.data];
        }
        return [...prev, ...uDataUsers?.data];
      });
    }
    // eslint-disable-next-line
  }, [uDataUsers]);

  const radioListGender = [
    {
      value: 1,
      labelName: t('managerCandidate.maleGender'),
    },
    {
      value: 2,
      labelName: t('managerCandidate.femaleGender'),
    },
  ];

  const radioListPrequalification = [
    {
      value: 1,
      labelName: t('managerCandidate.throughPrequalification'),
    },
    {
      value: 0,
      labelName: t('managerCandidate.didNotPassPrequalification'),
    },
  ];

  const handleSubmitForm = async (dataSubmit) => {
    if (errorDate?.birthday || errorDate?.apply_date) {
      return;
    }
    const {
      full_name,
      birthday,
      sex,
      email,
      mobile,
      school,
      experience,
      source_cv,
      presenter_id,
      apply_date,
      link_cv_online,
      position_id,
      skill_id,
      level_id,
      pass_prequalification,
      source_cv_text,
      is_freelancer,
      note,
      candidate_languages,
    } = dataSubmit;
    setStateButton(true);
    let response = {};
    const fb = new FormData();
    fb.append('full_name', full_name);
    namePresenter && fb.append('presenter_name', namePresenter);
    birthday && fb.append('birthday', moment(birthday, 'DD/MM/YYYY').format('YYYY/MM/DD'));
    fb.append('email', email);
    fb.append('mobile', mobile);
    fb.append('school', school);
    fb.append('experience', experience);
    fb.append('sex', sex);
    fb.append('is_freelancer', is_freelancer ? 1 : 0);
    fb.append('apply_date', moment(apply_date, 'DD/MM/YYYY').format('YYYY/MM/DD'));
    link_cv_online && fb.append('link_cv_online', link_cv_online);
    fb.append('position_id', position_id);
    skill_id && fb.append('skill_id', skill_id);
    fb.append('level_id', level_id);
    fb.append('source_cv', source_cv ?? source_cv);
    attchmentCV && fb.append('cv_offline_info_temp', JSON.stringify(attchmentCV));
    attchmentCV && fb.append('cv_offline_info', JSON.stringify(attchmentCV));
    fb.append('pass_prequalification', pass_prequalification);
    presenter_id && !sourceCvText && fb.append('presenter_id', presenter_id);
    sourceCvText && fb.append('source_cv_text', source_cv_text);
    note && fb.append('note', note);
    fb.append('candidate_languages', JSON.stringify(candidate_languages.filter((x) => x.language_id)));
    response = await apiCreateCandidateCV(fb);

    if (response?.data?.status === HTTP_OK) {
      setMessage(t('managerCandidate.createCandidateSuccess'));
      setDataDetail({
        candidate_id: response?.data?.id,
      });
      setStateButton(false);
      setShowAlert(true);
      clearErrors();
      await queryClient.invalidateQueries(USE_GET_LIST_CANDIDATE);
    } else {
      if (errorSubmit(response?.data?.code)) {
        if (response?.data?.code === CODE_DATA_EXISTS) {
          setDataDetail({
            candidate_id: response?.data?.id,
          });
          alertConfirmDuplicateCandidate(t, confirmAlert, response?.data?.name_hr, () =>
            handleRedirect.current?.handelClick.click(),
          );
          setStateButton(false);
          return;
        }
        setDataDetail();
        setMessage(t(errorSubmit(response?.data?.code)));
        setShowAlertError(true);
        setStateButton(false);
      }
    }
  };

  const { parseCv, isParsingCv, parseCvResult, resetParseCv } = useParseCv({
    getValues,
    setValue,
    getOptions: () =>
      getParseCvOptions({
        positions: dataPosition,
        levels: dataLevel,
        experiences: dataExperience,
        languages: uDataListLanguage,
        schools: dataListSchool,
      }),
    onFilled: ({ values, languages }) => {
      if (values.birthday) setAiBirthday(moment(values.birthday, 'DD/MM/YYYY').toDate());
      if (languages) replaceLanguages(languages);
      setAiFillKey((prev) => ({
        birthday: values.birthday ? prev.birthday + 1 : prev.birthday,
        school: values.school ? prev.school + 1 : prev.school,
      }));
    },
  });

  const { mutate: uploadCV, isLoading: isLoadingUploadCV } = useMutation((formData) => apiUploadCV(formData), {
    onSuccess: (response) => {
      setAttchmentCV(response.data?.data);
      setError('link_cv_online', '');
      setValue('is_file_upload', true);
      parseCv(response.data?.data?.url);
    },
    onError: () => {
      setMessage(t('messages.systemError'));
      setShowAlertError(true);
      setAttchmentCV();
      setValue('is_file_upload', false);
      resetParseCv();
    },
  });

  const onUploadAttchmentCV = async (event) => {
    if (event.target.files.length > 0) {
      if (event.target.files[0].size / 1024 / 1024 >= 25) {
        $('#attchment-cv').val('');
        setMessage(t('messages.pleaseUploadFileUnder25mb'));
        setShowAlertError(true);
        setAttchmentCV();
        setValue('is_file_upload', false);
        return;
      }

      var regex = new RegExp('(.*?).(docx|doc|pdf|jpg|jpeg|png|xlsx|csv)$');
      if (!regex.test(event.target.files[0].name.toLowerCase())) {
        setMessage(t('messages.pleaseUploadImagesInTheCorrectFormat'));
        setShowAlertError(true);
        setAttchmentCV();
        setValue('is_file_upload', false);
        return;
      }
      const formData = new FormData();
      formData.append('file_cv', event.target.files[0]);
      uploadCV(formData);
    }
  };

  // Watch value type timekeeping
  const watchTypePositionIdValue = useWatch({
    control,
    name: 'position_id',
  });

  // Watch value type source_cv
  const watchTypeSourceCvValue = useWatch({
    control,
    name: 'source_cv',
  });

  const {
    fields: candidate_languages,
    append: append,
    remove: remove,
    replace: replaceLanguages,
  } = useFieldArray({
    control,
    name: 'candidate_languages',
  });

  const listSkills = _groupBy(uDataSkill, 'position_id');

  useEffect(() => {
    setValue(
      'is_skill',
      uDataSkill?.filter((el) => Number(el.position_id) === Number(watchTypePositionIdValue))?.length > 0
        ? true
        : false,
    );
    if (!watchTypePositionIdValue || !listSkills[watchTypePositionIdValue]) {
      setValue('skill_id', null);
    } else {
      setValue('skill_id', listSkills[watchTypePositionIdValue][0].id);
    }
    // eslint-disable-next-line
  }, [watchTypePositionIdValue]);

  // Watch value type timekeeping
  const watchSchoolIdValue = useWatch({
    control,
    name: 'school',
  });

  // Watch value birthday
  const watchBirthdayValue = useWatch({
    control,
    name: 'birthday',
  });

  // Watch value birthday
  const watchApplyDateValue = useWatch({
    control,
    name: 'apply_date',
  });

  useEffect(() => {
    // eslint-disable-next-line
    if (!watchApplyDateValue || watchApplyDateValue == 'Invalid Date' || watchApplyDateValue?.length < 10) {
      return;
    }
    if (watchApplyDateValue?.length === 10) {
      if (checkMaxDateToday(watchApplyDateValue)) {
        setErrorDate((prev) => {
          return { ...prev, apply_date: true };
        });
      } else {
        setErrorDate((prev) => {
          return { ...prev, apply_date: false };
        });
      }
    }
  }, [watchApplyDateValue]);

  useEffect(() => {
    // eslint-disable-next-line
    if (!watchBirthdayValue || watchBirthdayValue == 'Invalid Date' || watchBirthdayValue?.length < 10) {
      return;
    }
    if (watchBirthdayValue?.length === 10) {
      if (checkMaxDateToday(watchBirthdayValue)) {
        setErrorDate((prev) => {
          return { ...prev, birthday: true };
        });
      } else {
        setErrorDate((prev) => {
          return { ...prev, birthday: false };
        });
      }
    }
  }, [watchBirthdayValue]);

  // Watch value type source_cv
  const watchPresenterIdValue = useWatch({
    control,
    name: 'presenter_id',
  });

  const onHandleChangeSelect = (value) => {
    let data = dataListSourceCV?.filter((item) => (item.id === value ? item.name : null));
    if (data?.length && SOURCE_CV_TEXT.indexOf(data[0].name.toLowerCase()) > -1) {
      setSourceCvText(value);
    } else {
      setSourceCvText('');
    }
  };

  return (
    <>
      <ModalComponent
        toggle={() => setShowModal(!isShowModal)}
        isShowModal={isShowModal}
        title={t('managerCandidate.addCandidate')}
        classNameAdd="modal-create-candidate"
      >
        <NavLink
          to={{
            pathname: dataDetail && '/admin/candidate-detail/' + dataDetail?.candidate_id,
          }}
          target="_blank"
          ref={(input) => {
            handleRedirect.current.handelClick = input;
          }}
          className={'link-to-detail'}
        ></NavLink>
        <Box autoComplete="off" onSubmit={handleSubmit(handleSubmitForm)}>
          <Grid container spacing={3}>
            <Grid item xs={12} className="text-modal">
              {t('managerCandidate.inforBasic')}
            </Grid>
            <Grid item md={12} className="item-field">
              <CustomInputYup
                label={t('common.fullName')}
                name={`full_name`}
                control={control}
                register={register}
                errors={errors}
                useWatch={useWatch}
                required
                maxLength={MAX_LENGTH_25}
                invalidPattern={/[0-9!@#\\$%\\^&\\*()_\\+-={};'`~:",\\.<>\\|\\?\\\\\\/\]\\[]+/}
              />
            </Grid>
            <Grid item md={12} className="item-field">
              <DateDay
                key={`birthday-${aiFillKey.birthday}`}
                label={t('common.birthday')}
                name="birthday"
                error={errors?.birthday?.message}
                addErrors={errorDate?.birthday && t('messages.pleaseEnteraDateThatIsLessThanTheCurrentDate')}
                control={control}
                setValue={setValue}
                register={register}
                setError={setError}
                isShowModal={isShowModal}
                defaultValue={aiBirthday}
                maxDate={moment()}
              />
            </Grid>
            <Grid item md={12} className="item-field radio-label-container">
              <span className="label">{t('common.gender')}</span>
              <CustomRadioInput
                control={control}
                radioList={radioListGender}
                defaultValue={1}
                name="sex"
                setValue={setValue}
              />
            </Grid>
            <Grid item md={12} className="item-field">
              <CusromInputNumber
                label={t('common.phone')}
                name={`mobile`}
                control={control}
                register={register}
                errors={errors}
                useWatch={useWatch}
                required
                setValue={setValue}
                phone={true}
              />
            </Grid>
            <Grid item md={12} className="item-field">
              <CustomInputYup
                label={t('common.email')}
                name={`email`}
                control={control}
                register={register}
                errors={errors}
                useWatch={useWatch}
                required
                maxLength={MAX_LENGTH_256}
              />
            </Grid>
            <Grid item md={12} className="item-field">
              <Autocomplete
                key={`school-${aiFillKey.school}`}
                sx={{ width: 300 }}
                options={dataListSchool}
                autoHighlight
                className="school"
                onChange={(e, values, reason, detail) => {
                  if (values?.id > 0) {
                    setError('school', '');
                  }
                  setValue('school', values?.id);
                }}
                defaultValue={dataListSchool?.find((item) => item?.id === watchSchoolIdValue)}
                getOptionLabel={(option) => option?.name}
                renderOption={(props, option) => (
                  <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props} key={option.id}>
                    {option.name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className={styles.schoolField}
                    error={errors?.school?.message ? true : false}
                    label={t('managerCandidate.school')}
                    inputProps={{
                      ...params.inputProps,
                      maxLength: MAX_LENGTH_50,
                      autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                  />
                )}
              />
              {errors?.school?.message && <p className="error-input error">{errors?.school?.message}</p>}
            </Grid>
            <AddMoreLanguage
              Controller={Controller}
              control={control}
              errors={errors}
              candidate_languages={
                candidate_languages?.length !== 0 ? candidate_languages : defaultLanguage.candidate_languages
              }
              setError={setError}
              append={append}
              remove={remove}
              mapLanguage={mapLanguage}
            />
            <Grid item xs={12} className="text-modal item-field">
              {t('managerCandidate.inforApply')}
            </Grid>
            <Grid item md={6} className="item-field">
              <SelectField
                name="position_id"
                label={t('masterData.StandardIndex.position')}
                error={errors?.position_id?.message}
                control={control}
                required
                setValue={setValue}
                useWatch={useWatch}
                register={register}
                isShowModal={isShowModal}
                isRequired
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: {
                        xs: 350,
                      },
                    },
                  },
                }}
              >
                {dataPosition?.map((item) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </SelectField>
            </Grid>
            <Grid item md={6} className="item-field">
              <SelectField
                name="skill_id"
                label={t('masterData.StandardIndex.skill')}
                error={errors?.skill_id?.message}
                control={control}
                required
                defaultValue={''}
                setValue={setValue}
                useWatch={useWatch}
                register={register}
                isShowModal={isShowModal}
                disabled={
                  watchTypePositionIdValue &&
                  uDataSkill.filter((el) => Number(el.position_id) === Number(watchTypePositionIdValue))?.length > 0
                    ? false
                    : true
                }
                isRequired={
                  watchTypePositionIdValue &&
                  uDataSkill.filter((el) => Number(el.position_id) === Number(watchTypePositionIdValue))?.length > 0
                    ? true
                    : false
                }
              >
                {uDataSkill &&
                  uDataSkill
                    .filter((el) => Number(el.position_id) === Number(watchTypePositionIdValue))
                    ?.map((item) => (
                      <MenuItem value={item.id} key={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
              </SelectField>
            </Grid>
            <Grid item md={6} className="item-field">
              <SelectField
                name="level_id"
                label={t('masterData.StandardIndex.levelApply')}
                error={errors?.level_id?.message}
                control={control}
                required
                setValue={setValue}
                useWatch={useWatch}
                register={register}
                isShowModal={isShowModal}
                isRequired
              >
                {dataLevel?.map((item) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </SelectField>
            </Grid>
            <Grid item md={6} className="item-field">
              <SelectField
                name="experience"
                label={t('managerJD.experience')}
                error={errors?.experience?.message}
                control={control}
                required
                setValue={setValue}
                useWatch={useWatch}
                register={register}
                isShowModal={isShowModal}
                isRequired
              >
                {dataExperience?.map((item) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </SelectField>
            </Grid>
            <Grid item md={12} className="item-field">
              <SelectField
                name="source_cv"
                label={t('managerCandidate.sourceCv')}
                error={errors?.source_cv?.message}
                control={control}
                required
                setValue={setValue}
                useWatch={useWatch}
                register={register}
                isShowModal={isShowModal}
                isRequired
                onHandleChangeSelect={onHandleChangeSelect}
              >
                {dataListSourceCV?.map((item) => (
                  <MenuItem value={item.id} key={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </SelectField>
            </Grid>
            {sourceCvText && (
              <Grid item md={12} className="item-field">
                <CustomInputYup
                  label={t('managerCandidate.Outsourcing/contributor/headhunt')}
                  name={`source_cv_text`}
                  maxLength={MAX_LENGTH_50}
                  errors={errors}
                  control={control}
                  register={register}
                  useWatch={useWatch}
                  required
                />
              </Grid>
            )}
            {watchTypeSourceCvValue === 1 && (
              <Grid item md={12} className="item-field">
                <AutoCompleteCustom
                  label={t('managerCandidate.fullNameIntroduce')}
                  options={dataUser}
                  setFilter={setFilter}
                  setValueField={setValue}
                  register={register}
                  name="presenter_id"
                  total={uDataUsers?.total}
                  isLoading={isLoadingDataUsers}
                  error={!Number.isInteger(watchPresenterIdValue) && errors?.presenter_id?.message}
                  setDataUser={setDataUser}
                  maxLength={MAX_LENGTH_50}
                  required={watchTypeSourceCvValue === 1 ? true : false}
                  setNamePresenter={setNamePresenter}
                  namePresenter={namePresenter}
                />
              </Grid>
            )}
            <Grid item md={12} className="item-field">
              <DateDay
                label={t('managerCandidate.dateApply')}
                name="apply_date"
                error={errors?.apply_date?.message}
                addErrors={errorDate?.apply_date && t('messages.pleaseEnteraDateThatIsLessThanTheCurrentDate')}
                control={control}
                setValue={setValue}
                register={register}
                setError={setError}
                isShowModal={isShowModal}
                defaultValue={null}
                maxDate={moment()}
                isRequired
              />
            </Grid>
            <Grid item md={12} className="item-field radio-label-container">
              <span className="label">{t('common.isFreelancer')}</span>
              <Controller
                control={control}
                name="is_freelancer"
                render={({ field }) => (
                  <Grid className="freelancer-create-job">
                    <Checkbox
                      {...field}
                      className="p-0"
                    />
                    <span className="ml-1">{t('common.yesEN')}</span>
                  </Grid>
                )}
              />
            </Grid>
            <Grid item xs={12} className="text-modal">
              {t('managerCandidate.infoCV')}
            </Grid>
            <Grid item md={12} className="item-field link-cv-input">
              <CustomInputYup
                label={t('managerCandidate.linkAttchment')}
                name={`link_cv_online`}
                control={control}
                register={register}
                errors={errors}
                addErrors={!attchmentCV && errors?.name?.link_cv_online}
                useWatch={useWatch}
                required={attchmentCV ? false : true}
                maxLength={MAX_LENGTH_250}
              />
            </Grid>
            <Grid item xs={12} className="text-modal item-field">
              <input
                id={'attchment-cv'}
                type="file"
                name="attchment_cv"
                style={{ display: 'none' }}
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xlsx,.csv"
                onChange={(event) => onUploadAttchmentCV(event)}
              />
              <label className="upload-file-cv" htmlFor={'attchment-cv'}>
                {<img src={iconAttchmentCV} alt="camera" width={'18px'} height="18px" />}{' '}
                {t('managerCandidate.upFileCvAttchment')}
                <label className="label-CV" htmlFor={'attchment-cv'}>
                  {t('managerCandidate.typeFileAccept')}
                </label>
              </label>
              {isLoadingUploadCV && <Loading type={LOADING_SM} addClass="loading-upload-cv" />}
              {!isLoadingUploadCV && attchmentCV && (
                <div className="info-cv-upload">
                  <div>
                    <img src={iconCvDefault} alt="camera" width={'60px'} height="60px" />
                  </div>
                  <div className="cv-name">
                    <p className="title">{attchmentCV.name}</p>
                    <p>{attchmentCV.size + ' kb'}</p>
                  </div>
                </div>
              )}
              <CvParseStatus isLoading={isParsingCv} result={parseCvResult} />
            </Grid>
            <Grid item xs={12} className="text-modal">
              {t('managerCandidate.prequalification')}
            </Grid>
            <Grid item xs={12} className="text-modal item-field radio-label-container">
              <CustomRadioInput
                control={control}
                radioList={radioListPrequalification}
                defaultValue={1}
                name="pass_prequalification"
                setValue={setValue}
              />
            </Grid>
            <Grid item xs={12} className="text-modal">
              {t('managerCandidate.noteCandidate')}
            </Grid>
            <Grid item xs={12}>
              <CustomInputYup
                label={t('managerCandidate.enterNoteCandidate')}
                name="note"
                addClass="w-100 note pl-15 pt-10 overflow-auto"
                control={control}
                errors={errors}
                useWatch={useWatch}
                maxLength={MAX_LENGTH_300}
                multiline
                rows={ROWS_TEXT_AREA_6}
                defaultValue={null}
                register={register}
              />
            </Grid>
            <Grid item md={6}>
              <ButtonComponent
                text={t('managerJD.cancel')}
                addClass="button-cancel btn-bg-yellow2"
                handleClick={() => setShowModal(false)}
              />
            </Grid>
            <Grid item md={6}>
              <ButtonComponent
                text={t('common.add')}
                addClass="button-submit btn-bg-yellow1"
                type="submit"
                handleClick={handleSubmit(handleSubmitForm)}
                hasDisabled={stateButton || isParsingCv}
                isLoading={stateButton}
              />
            </Grid>
          </Grid>
        </Box>
      </ModalComponent>
      <AlertComponent
        toggle={() => {
          setShowAlert(!isShowAlert);
          setShowModal(false);
        }}
        isShowAlert={isShowAlert}
        link={dataDetail && '/admin/candidate-detail/' + dataDetail?.candidate_id}
      >
        {message}
      </AlertComponent>
      <AlertComponent
        toggle={() => {
          setShowAlertError(!isShowAlertError);
        }}
        isShowAlert={isShowAlertError}
      >
        {message}
      </AlertComponent>
    </>
  );
};

export default CreateCandidateModal;
